module.exports = __webpack_public_path__ + "static/media/2tes chico.a0ed64e4.png";